import { render } from "./Gift.vue?vue&type=template&id=4f829428"
import script from "./Gift.vue?vue&type=script&lang=js"
export * from "./Gift.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__